import { hideModal, showModal } from "app/modules/modal-management/reducer/action";
import { getErrorEndOTP, getErrorMessage } from "app/shared/services/axios";
import { RESPONSEBASE } from "app/shared/services/services-model.type";
import { AxiosError, AxiosResponse } from "axios";
import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  fetchTermDepositListTopUpService,
  fetchTermDepositTopUpAuthService,
  fetchTermDepositTopUpConfirmService,
  fetchTermDepositTopUpCreateService,
} from "../services/term-deposit-top-up.service";
import {
  fetchTermDepositListTopUpFailure,
  fetchTermDepositListTopUpSuccess,
  fetchTermDepositTopUpAuthorizationFailure,
  fetchTermDepositTopUpAuthorizationSuccess,
  fetchTermDepositTopUpConfirmFailure,
  fetchTermDepositTopUpConfirmSuccess,
  fetchTermDepositTopUpCreateFailure,
  fetchTermDepositTopUpCreateSuccess,
} from "./actions";
import {
  FETCH_TERM_DEPOSIT_LIST_TOP_UP_REQUEST,
  FETCH_TERM_DEPOSIT_TOP_UP_AUTHORIZATION_KEY_REQUEST,
  FETCH_TERM_DEPOSIT_TOP_UP_CONFIRM_REQUEST,
  FETCH_TERM_DEPOSIT_TOP_UP_CREATE_REQUEST,
} from "./actions.type";
import {
  FetchTermDepositTopUpAuthorizationRequest,
  FetchTermDepositTopUpConfirmRequest,
  FetchTermDepositTopUpCreateRequest,
} from "./types";

function* fetchTermDepositListTopUpSaga() {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(fetchTermDepositListTopUpService);
    console.log("fetchTermDepositListTopUp response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTermDepositListTopUpSuccess(response.data.RESPONSEDATA?.LIST_ACCOUNT_PROFILE));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTermDepositListTopUpFailure(msg));
  }
}

function* fetchTermDepositTopUpCreateSaga(action: FetchTermDepositTopUpCreateRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTermDepositTopUpCreateService(action));
    console.log("fetchTermDepositTopUpCreate response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTermDepositTopUpCreateSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTermDepositTopUpCreateFailure(msg));
  }
}

function* fetchTermDepositTopUpConfirmSaga(action: FetchTermDepositTopUpConfirmRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTermDepositTopUpConfirmService(action));
    console.log("fetchTermDepositTopUpConfirm response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTermDepositTopUpConfirmSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTermDepositTopUpConfirmFailure(msg));
  }
}

function* fetchTermDepositTopUpAuthSaga(action: FetchTermDepositTopUpAuthorizationRequest) {
  try {
    yield put(showModal({ modalProps: { open: true }, modalType: "loading" }));
    const response: AxiosResponse<RESPONSEBASE> = yield call(() => fetchTermDepositTopUpAuthService(action));
    console.log("fetchTermDepositTopUpAuth response: ", response);
    yield put(hideModal());
    if (response.status === 200) {
      yield put(fetchTermDepositTopUpAuthorizationSuccess(response.data.RESPONSEDATA));
    }
  } catch (e: any | AxiosError) {
    yield put(hideModal());
    const msg = getErrorMessage(e, true);
    yield put(fetchTermDepositTopUpAuthorizationFailure(getErrorEndOTP(e), msg));
  }
}

function* termDepositTopUpSaga() {
  yield all([
    takeLatest(FETCH_TERM_DEPOSIT_LIST_TOP_UP_REQUEST, fetchTermDepositListTopUpSaga),
    takeLatest(FETCH_TERM_DEPOSIT_TOP_UP_CREATE_REQUEST, fetchTermDepositTopUpCreateSaga),
    takeLatest(FETCH_TERM_DEPOSIT_TOP_UP_CONFIRM_REQUEST, fetchTermDepositTopUpConfirmSaga),
    takeLatest(FETCH_TERM_DEPOSIT_TOP_UP_AUTHORIZATION_KEY_REQUEST, fetchTermDepositTopUpAuthSaga),
  ]);
}

export default termDepositTopUpSaga;
